import { useBoardDrop } from "../hooks/useDragAndDrop";
import TaskCard from "./TaskCard";
import "../styles/board.css";

const Board = ({
  board,
  tasks,
  users,
  onTaskClick,
  onDropTask,
  onAddTask,
  onTaskDone,
  toggleSelect,
  selectedTasks,
}) => {
  const { dropRef, isOver } = useBoardDrop(board.id, onDropTask);

  return (
    <div ref={dropRef} className={`board-column ${isOver ? "board-over" : ""}`}>
      <div className="board-header">
        <h3>{board.title}</h3>
        <button className="btn-small" onClick={() => onAddTask(board.id)}>
          + Task
        </button>
      </div>

      <div className="board-tasks">
        {tasks.map((task) => {
          const assignee = users.find((u) => u.id === task.assigneeId);

          return (
            <TaskCard
              key={task.id}
              task={task}
              assignee={assignee}
              onClick={() => onTaskClick(task)}
              onDone={onTaskDone}
              onSelect={toggleSelect}
              selected={selectedTasks.includes(task.id)}
              selectedTasks={selectedTasks}  // ⭐ send whole list for drag group
            />
          );
        })}

        {tasks.length === 0 && <div className="empty-board-text">No tasks yet.</div>}
      </div>
    </div>
  );
};

export default Board;
